(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-contact"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sc-about-contact]').forEach((root) => {
    const gallery = root.querySelector('[data-sc-about-contact-gallery]');
    if (!gallery) return;

    const originals = Array.from(gallery.children);
    if (!originals.length) return;

    // Duplicate once for seamless infinite scroll.
    originals.forEach((child) => {
      const clone = child.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      gallery.appendChild(clone);
    });

    let isDown = false;
    let isHovering = false;
    let startX = 0;
    let startScroll = 0;
    let moved = false;
    let paused = false;
    let rafId = 0;
    const speed = 0.35; // px per frame — slow continuous drift
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const loopWidth = () => {
      // Half of scrollWidth after duplication ≈ original content width.
      return gallery.scrollWidth / 2;
    };

    const normalizeScroll = () => {
      const half = loopWidth();
      if (half <= 0) return;
      if (gallery.scrollLeft >= half) {
        gallery.scrollLeft -= half;
      } else if (gallery.scrollLeft < 0) {
        gallery.scrollLeft += half;
      }
    };

    const tick = () => {
      if (!paused && !isDown && !isHovering && !reduceMotion) {
        gallery.scrollLeft += speed;
        normalizeScroll();
      }
      rafId = window.requestAnimationFrame(tick);
    };

    const onPointerDown = (event) => {
      if (event.pointerType === 'touch') return;
      isDown = true;
      moved = false;
      startX = event.clientX;
      startScroll = gallery.scrollLeft;
      gallery.classList.add('is-dragging');
      gallery.setPointerCapture(event.pointerId);
    };

    const onPointerMove = (event) => {
      if (!isDown) return;
      const delta = event.clientX - startX;
      if (Math.abs(delta) > 3) moved = true;
      gallery.scrollLeft = startScroll - delta;
      normalizeScroll();
    };

    const onPointerUp = (event) => {
      if (!isDown) return;
      isDown = false;
      gallery.classList.remove('is-dragging');
      try {
        gallery.releasePointerCapture(event.pointerId);
      } catch (e) {}
    };

    gallery.addEventListener('pointerdown', onPointerDown);
    gallery.addEventListener('pointermove', onPointerMove);
    gallery.addEventListener('pointerup', onPointerUp);
    gallery.addEventListener('pointercancel', onPointerUp);
    gallery.addEventListener('dragstart', (event) => event.preventDefault());
    gallery.addEventListener('mouseenter', () => {
      isHovering = true;
    });
    gallery.addEventListener('mouseleave', () => {
      isHovering = false;
    });
    gallery.addEventListener(
      'click',
      (event) => {
        if (!moved) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );

    // Pause when tab is hidden to save work.
    document.addEventListener('visibilitychange', () => {
      paused = document.hidden;
    });

    if (!reduceMotion) {
      rafId = window.requestAnimationFrame(tick);
    }

    root.addEventListener(
      'sc:about-contact:destroy',
      () => {
        if (rafId) window.cancelAnimationFrame(rafId);
      },
      { once: true }
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-who"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sc-about-who]').forEach((root) => {
    const tabs = Array.from(root.querySelectorAll('[data-sc-about-who-tab]'));
    const bios = Array.from(root.querySelectorAll('[data-sc-about-who-bio]'));
    const media = Array.from(root.querySelectorAll('[data-sc-about-who-media]'));
    const avatars = Array.from(root.querySelectorAll('[data-sc-about-who-avatar-item]'));
    const progress = root.querySelector('[data-sc-about-who-progress]');
    if (!tabs.length) return;

    const total = tabs.length;

    const setActive = (index) => {
      tabs.forEach((tab, i) => {
        const on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      bios.forEach((el) => {
        const on = Number(el.getAttribute('data-index')) === index;
        el.classList.toggle('is-hidden', !on);
        el.toggleAttribute('hidden', !on);
      });

      media.forEach((el) => {
        const on = Number(el.getAttribute('data-index')) === index;
        el.classList.toggle('is-hidden', !on);
        el.toggleAttribute('hidden', !on);
      });

      avatars.forEach((el) => {
        const on = Number(el.getAttribute('data-sc-about-who-avatar-item')) === index;
        el.classList.toggle('is-active', on);
      });

      if (progress) {
        const width = 100 / total;
        progress.style.width = width + '%';
        progress.style.transform = 'translateX(' + index * 100 + '%)';
      }
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        setActive(Number(tab.getAttribute('data-index')) || 0);
      });
    });

    setActive(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flavors"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sc-flavors]').forEach((root) => {
    const models = root.querySelectorAll('[data-sc-flavors-model]');
    if (!models.length) return;

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const interacting = new WeakSet();

    const scrollProgress = () => {
      const rect = root.getBoundingClientRect();
      const view = window.innerHeight || 1;
      return clamp(
        1 - (rect.top + rect.height * 0.35) / (view + rect.height * 0.3),
        0,
        1
      );
    };

    const applyScrollOrbit = () => {
      const progress = scrollProgress();
      models.forEach((model) => {
        if (interacting.has(model)) return;
        const baseYaw = Number(model.getAttribute('data-yaw')) || 180;
        const pitch = Number(model.getAttribute('data-pitch')) || 72;
        const zoom = Number(model.getAttribute('data-zoom')) || 105;
        const yaw = baseYaw + progress * 140;
        model.cameraOrbit = `${yaw.toFixed(2)}deg ${pitch}deg ${zoom}%`;
        if (typeof model.jumpCameraToGoal === 'function') model.jumpCameraToGoal();
      });
    };

    const bakeUserYaw = (model) => {
      if (!model.getCameraOrbit) return;
      const orbit = model.getCameraOrbit();
      const yawDeg = (orbit.theta * 180) / Math.PI;
      const progress = scrollProgress();
      model.setAttribute('data-yaw', String(yawDeg - progress * 140));
    };

    models.forEach((model) => {
      model.addEventListener('camera-change', (event) => {
        if (!event.detail || event.detail.source !== 'user-interaction') return;
        interacting.add(model);
        bakeUserYaw(model);
      });
      model.addEventListener('pointerdown', () => interacting.add(model));
    });

    const endInteraction = () => {
      models.forEach((model) => {
        if (!interacting.has(model)) return;
        bakeUserYaw(model);
        interacting.delete(model);
      });
    };

    window.addEventListener('pointerup', endInteraction);
    window.addEventListener('pointercancel', endInteraction);

    const loadModel = (model) => {
      const src = model.getAttribute('data-src');
      if (!src || model.getAttribute('src')) return Promise.resolve();
      return new Promise((resolve) => {
        const done = () => resolve();
        model.addEventListener('load', done, { once: true });
        model.addEventListener('error', done, { once: true });
        model.src = src;
      });
    };

    const loadWhenVisible = () => {
      const queue = Array.prototype.slice.call(models);
      const run = () => {
        const model = queue.shift();
        if (!model) return;
        loadModel(model).then(run);
      };
      run();
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0] || !entries[0].isIntersecting) return;
        observer.disconnect();
        loadWhenVisible();
      }, { rootMargin: '400px 0px' });
      observer.observe(root);
    } else {
      loadWhenVisible();
    }

    applyScrollOrbit();
    window.addEventListener('scroll', applyScrollOrbit, { passive: true });
    window.addEventListener('resize', applyScrollOrbit);
    models.forEach((model) => model.addEventListener('load', applyScrollOrbit));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__scLocaleBound) return;
    window.__scLocaleBound = true;

    const closeAll = (except) => {
      document.querySelectorAll('[data-sc-locale]').forEach((root) => {
        if (except && root === except) return;
        root.classList.remove('is-open');
        const trigger = root.querySelector('[data-sc-locale-trigger]');
        const menu = root.querySelector('[data-sc-locale-menu]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (menu) menu.hidden = true;
      });
    };

    document.querySelectorAll('[data-sc-locale]').forEach((root) => {
      const form = root.querySelector('form');
      const trigger = root.querySelector('[data-sc-locale-trigger]');
      const menu = root.querySelector('[data-sc-locale-menu]');
      const input = root.querySelector('[data-sc-locale-input]');
      if (!trigger) return;

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!menu) return;
        const open = menu.hidden;
        closeAll();
        if (open) {
          root.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          menu.hidden = false;
        }
      });

      if (!menu || !form || !input) return;

      menu.querySelectorAll('[data-value]').forEach((btn) => {
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          const value = btn.getAttribute('data-value');
          if (!value || value === input.value) {
            closeAll();
            return;
          }
          input.value = value;
          form.submit();
        });
      });
    });

    document.addEventListener('click', () => closeAll());
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.__scLocaleBound) {
      window.__scLocaleBound = true;

      const closeAll = (except) => {
        document.querySelectorAll('[data-sc-locale]').forEach((node) => {
          if (except && node === except) return;
          node.classList.remove('is-open');
          const trigger = node.querySelector('[data-sc-locale-trigger]');
          const menu = node.querySelector('[data-sc-locale-menu]');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          if (menu) menu.hidden = true;
        });
      };

      document.querySelectorAll('[data-sc-locale]').forEach((node) => {
        const form = node.querySelector('form');
        const trigger = node.querySelector('[data-sc-locale-trigger]');
        const menu = node.querySelector('[data-sc-locale-menu]');
        const input = node.querySelector('[data-sc-locale-input]');
        if (!trigger) return;

        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (!menu) return;
          const open = menu.hidden;
          closeAll();
          if (open) {
            node.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            menu.hidden = false;
          }
        });

        if (!menu || !form || !input) return;

        menu.querySelectorAll('[data-value]').forEach((btn) => {
          btn.addEventListener('click', (event) => {
            event.preventDefault();
            const value = btn.getAttribute('data-value');
            if (!value || value === input.value) {
              closeAll();
              return;
            }
            input.value = value;
            form.submit();
          });
        });
      });

      document.addEventListener('click', () => closeAll());
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeAll();
      });
    }

    const root = document.querySelector('[data-sc-header]');
    if (!root) return;

    const slides = Array.from(root.querySelectorAll('[data-sc-announce-slide]'));
    const prev = root.querySelector('[data-sc-announce-prev]');
    const next = root.querySelector('[data-sc-announce-next]');
    let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (index < 0) index = 0;

    const show = (nextIndex) => {
      if (slides.length === 0) return;
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.hidden = !active;
      });
    };

    prev?.addEventListener('click', () => show(index - 1));
    next?.addEventListener('click', () => show(index + 1));

    if (slides.length > 1) {
      window.setInterval(() => show(index + 1), 5000);
    }

    const toggle = root.querySelector('[data-sc-header-toggle]');
    const mobile = root.querySelector('[data-sc-header-mobile]');
    const setMenuOpen = (open) => {
      if (!mobile || !toggle) return;
      root.classList.toggle('is-menu-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) {
        mobile.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', 'Close menu');
      } else {
        mobile.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
      }
    };

    toggle?.addEventListener('click', () => {
      setMenuOpen(mobile?.hasAttribute('hidden'));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root.classList.contains('is-menu-open')) {
        setMenuOpen(false);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["key-ingredients-static"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sc-ingredients-static]').forEach((section) => {
    const items = section.querySelectorAll('.sc-ingredients-static__item');
    const firstItem = items[0];

    const ensureOneOpen = () => {
      if (!firstItem) return;
      if (![...items].some((item) => item.open)) firstItem.open = true;
    };

    items.forEach((item) => {
      const summary = item.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', (event) => {
          if (item.open) event.preventDefault();
        });
      }

      item.addEventListener('toggle', () => {
        if (item.open) {
          items.forEach((other) => {
            if (other !== item) other.removeAttribute('open');
          });
        } else {
          ensureOneOpen();
        }
      });
    });

    ensureOneOpen();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["key-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sc-ingredients]').forEach((section) => {
    const items = section.querySelectorAll('.sc-ingredients__item');
    const mediaItems = section.querySelectorAll('[data-ingredient-media]');

    const ensureSrc = (video) => {
      if (!video) return;
      const src = video.getAttribute('src');
      const pending = video.getAttribute('data-src');
      if (!src && pending) video.src = pending;
    };

    const playVideo = (video) => {
      if (!video) return;
      video.muted = true;
      video.playsInline = true;
      video.preload = 'auto';
      ensureSrc(video);
      const play = () => video.play().catch(() => {});
      if (video.readyState >= 2) play();
      else video.addEventListener('canplay', play, { once: true });
    };

    const isMobile = () => window.matchMedia('(max-width: 989px)').matches;

    const syncMedia = () => {
      const open = section.querySelector('.sc-ingredients__item[open]');
      const id = open ? open.getAttribute('data-ingredient-id') : null;
      const mobile = isMobile();
      let activeVideo = null;

      mediaItems.forEach((media) => {
        const active = !mobile && Boolean(id) && media.getAttribute('data-ingredient-media') === id;
        media.classList.toggle('is-active', active);
        const video = media.querySelector('video');
        if (!video) return;
        if (active) {
          activeVideo = video;
          playVideo(video);
        } else {
          video.pause();
        }
      });

      items.forEach((item) => {
        const video = item.querySelector('.sc-ingredients__item-video');
        if (!video || video.tagName !== 'VIDEO') return;
        if (mobile && item.open) {
          activeVideo = video;
          playVideo(video);
        } else {
          video.pause();
        }
      });

      return activeVideo;
    };

    const prefetchOthers = (activeVideo) => {
      const videos = isMobile()
        ? section.querySelectorAll('.sc-ingredients__item-video')
        : section.querySelectorAll('[data-ingredient-media] video');
      videos.forEach((video) => {
        if (!video || video.tagName !== 'VIDEO' || video === activeVideo) return;
        video.preload = 'auto';
        ensureSrc(video);
      });
    };

    const firstItem = items[0];

    const ensureOneOpen = () => {
      if (!firstItem) return;
      if (![...items].some((item) => item.open)) firstItem.open = true;
    };

    items.forEach((item) => {
      const summary = item.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', (event) => {
          if (item.open) event.preventDefault();
        });
      }

      item.addEventListener('toggle', () => {
        if (item.open) {
          items.forEach((other) => {
            if (other !== item) other.removeAttribute('open');
          });
        } else {
          ensureOneOpen();
        }
        syncMedia();
      });
    });

    ensureOneOpen();

    window.matchMedia('(max-width: 989px)').addEventListener('change', () => {
      syncMedia();
    });

    const start = () => {
      const activeVideo = syncMedia();
      if (!activeVideo) return;
      if (activeVideo.readyState >= 3) {
        prefetchOthers(activeVideo);
        return;
      }
      activeVideo.addEventListener('canplaythrough', () => prefetchOthers(activeVideo), { once: true });
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0] || !entries[0].isIntersecting) return;
        start();
        observer.disconnect();
      }, { rootMargin: '300px 0px' });
      observer.observe(section);
    } else {
      start();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promise-cards"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sc-promise]').forEach((root) => {
    const grid = root.querySelector('[data-sc-promise-grid]');
    const bar = root.querySelector('[data-sc-promise-scrollbar]');
    const thumb = root.querySelector('[data-sc-promise-thumb]');
    if (!grid || !bar || !thumb) return;

    const mq = window.matchMedia('(max-width: 749px)');

    const update = () => {
      if (!mq.matches) {
        bar.hidden = true;
        thumb.style.width = '';
        thumb.style.transform = '';
        return;
      }

      const max = grid.scrollWidth - grid.clientWidth;
      if (max <= 1) {
        bar.hidden = true;
        return;
      }

      bar.hidden = false;
      const ratio = grid.clientWidth / grid.scrollWidth;
      const thumbWidth = Math.max(ratio * 100, 18);
      const travel = 100 - thumbWidth;
      const progress = grid.scrollLeft / max;
      thumb.style.width = thumbWidth + '%';
      thumb.style.transform = 'translateX(' + ((progress * travel) / thumbWidth) * 100 + '%)';
    };

    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (mq.addEventListener) mq.addEventListener('change', update);
    else mq.addListener(update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-flavors-clickable"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sc-flavors]').forEach((root) => {
    const slider = root.querySelector('[data-sc-slider]');
    const prevBtn = root.querySelector('.sc-flavors__arrow--prev');
    const nextBtn = root.querySelector('.sc-flavors__arrow--next');

    if (slider && prevBtn && nextBtn) {
      const updateArrows = () => {
        const scrollLeft = slider.scrollLeft;
        const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
        
        // Toleransi kecil untuk floating point rounding
        if (scrollLeft <= 2) {
          prevBtn.classList.add('is-hidden');
        } else {
          prevBtn.classList.remove('is-hidden');
        }

        if (scrollLeft >= maxScrollLeft - 2) {
          nextBtn.classList.add('is-hidden');
        } else {
          nextBtn.classList.remove('is-hidden');
        }
      };

      prevBtn.addEventListener('click', () => {
        slider.scrollBy({ left: -slider.clientWidth, behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        slider.scrollBy({ left: slider.clientWidth, behavior: 'smooth' });
      });

      slider.addEventListener('scroll', updateArrows);
      window.addEventListener('resize', updateArrows);
      
      // Jalankan sekali saat load pertama
      updateArrows();
    }

    const models = root.querySelectorAll('[data-sc-flavors-model]');
    if (!models.length) return;

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const interacting = new WeakSet();

    const scrollProgress = () => {
      const rect = root.getBoundingClientRect();
      const view = window.innerHeight || 1;
      return clamp(
        1 - (rect.top + rect.height * 0.35) / (view + rect.height * 0.3),
        0,
        1
      );
    };

    const applyScrollOrbit = () => {
      const progress = scrollProgress();
      models.forEach((model) => {
        if (interacting.has(model)) return;
        const baseYaw = Number(model.getAttribute('data-yaw')) || 180;
        const pitch = Number(model.getAttribute('data-pitch')) || 72;
        const zoom = Number(model.getAttribute('data-zoom')) || 105;
        const yaw = baseYaw + progress * 140;
        model.cameraOrbit = `${yaw.toFixed(2)}deg ${pitch}deg ${zoom}%`;
        if (typeof model.jumpCameraToGoal === 'function') model.jumpCameraToGoal();
      });
    };

    const bakeUserYaw = (model) => {
      if (!model.getCameraOrbit) return;
      const orbit = model.getCameraOrbit();
      const yawDeg = (orbit.theta * 180) / Math.PI;
      const progress = scrollProgress();
      model.setAttribute('data-yaw', String(yawDeg - progress * 140));
    };

    models.forEach((model) => {
      model.addEventListener('camera-change', (event) => {
        if (!event.detail || event.detail.source !== 'user-interaction') return;
        interacting.add(model);
        bakeUserYaw(model);
      });
      model.addEventListener('pointerdown', () => interacting.add(model));
    });

    const endInteraction = () => {
      models.forEach((model) => {
        if (!interacting.has(model)) return;
        bakeUserYaw(model);
        interacting.delete(model);
      });
    };

    window.addEventListener('pointerup', endInteraction);
    window.addEventListener('pointercancel', endInteraction);

    const loadModel = (model) => {
      const src = model.getAttribute('data-src');
      if (!src || model.getAttribute('src')) return Promise.resolve();
      return new Promise((resolve) => {
        const done = () => resolve();
        model.addEventListener('load', done, { once: true });
        model.addEventListener('error', done, { once: true });
        model.src = src;
      });
    };

    const loadWhenVisible = () => {
      const queue = Array.prototype.slice.call(models);
      const run = () => {
        const model = queue.shift();
        if (!model) return;
        loadModel(model).then(run);
      };
      run();
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0] || !entries[0].isIntersecting) return;
        observer.disconnect();
        loadWhenVisible();
      }, { rootMargin: '400px 0px' });
      observer.observe(root);
    } else {
      loadWhenVisible();
    }

    applyScrollOrbit();
    window.addEventListener('scroll', applyScrollOrbit, { passive: true });
    window.addEventListener('resize', applyScrollOrbit);
    models.forEach((model) => model.addEventListener('load', applyScrollOrbit));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-sc-search-page]');
    if (!root) return;
    const input = root.querySelector('[data-sc-search-page-input]');
    const clearBtn = root.querySelector('[data-sc-search-page-clear]');
    if (!input || !clearBtn) return;

    const syncClear = () => {
      clearBtn.hidden = !input.value.trim();
    };

    input.addEventListener('input', syncClear);
    clearBtn.addEventListener('click', () => {
      input.value = '';
      syncClear();
      input.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sip-benefits-2"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sc-benefits]').forEach((root) => {
    const radios = root.querySelectorAll('.sc-benefits__radio');
    const details = root.querySelectorAll('.sc-benefits__detail');
    const model = root.querySelector('[data-sc-benefits-model]');

    const sync = () => {
      radios.forEach((radio, index) => {
        const detail = details[index];
        if (!detail) return;
        detail.toggleAttribute('hidden', !radio.checked);
      });
    };

    radios.forEach((radio) => radio.addEventListener('change', sync));
    sync();

    if (!model) return;

    let userOrbiting = false;
    let clickSpin = 0;
    let clickSpinTarget = 0;
    let baseYaw = 25;
    const allowTilt = model.getAttribute('data-allow-tilt') === 'true';
    const lockedPitch = 72;

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

    const updateFromScroll = () => {
      const rect = root.getBoundingClientRect();
      const view = window.innerHeight || 1;
      const progress = clamp(
        1 - ((rect.top + rect.height * 0.35) / (view + rect.height * 0.3)),
        0,
        1
      );
      baseYaw = 25 + progress * 140;
    };

    const render = () => {
      if (!userOrbiting) {
        const yaw = baseYaw + clickSpin;
        const pitch = allowTilt
          ? 68 + Math.sin(((baseYaw + clickSpin) * Math.PI) / 180) * 4
          : lockedPitch;
        model.cameraOrbit = `${yaw.toFixed(2)}deg ${pitch.toFixed(2)}deg 105%`;
      }

      if (Math.abs(clickSpinTarget - clickSpin) > 0.2) {
        clickSpin += (clickSpinTarget - clickSpin) * 0.08;
      } else {
        clickSpin = clickSpinTarget;
      }

      window.requestAnimationFrame(render);
    };

    updateFromScroll();
    window.requestAnimationFrame(render);
    window.addEventListener('scroll', updateFromScroll, { passive: true });
    window.addEventListener('resize', updateFromScroll);

    model.addEventListener('mousedown', () => {
      userOrbiting = true;
    });
    model.addEventListener(
      'touchstart',
      () => {
        userOrbiting = true;
      },
      { passive: true }
    );

    const resumeScrollDrive = () => {
      window.setTimeout(() => {
        userOrbiting = false;
        updateFromScroll();
      }, 1800);
    };

    model.addEventListener('mouseup', resumeScrollDrive);
    model.addEventListener('touchend', resumeScrollDrive);

    model.addEventListener('click', () => {
      clickSpinTarget += 90;
      if (model.availableAnimations && model.availableAnimations.length) {
        try {
          model.play({ repetitions: 1 });
        } catch (e) {}
      }
    });

    model.addEventListener('load', () => {
      model.classList.add('is-ready');
      updateFromScroll();
    });
    if (model.loaded) model.classList.add('is-ready');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sip-benefits"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sc-benefits]').forEach((root) => {
    const radios = root.querySelectorAll('.sc-benefits__radio');
    const details = root.querySelectorAll('.sc-benefits__detail');
    const model = root.querySelector('[data-sc-benefits-model]');

    const sync = () => {
      radios.forEach((radio, index) => {
        const detail = details[index];
        if (!detail) return;
        detail.toggleAttribute('hidden', !radio.checked);
      });
    };

    radios.forEach((radio) => radio.addEventListener('change', sync));
    sync();

    if (!model) return;

    let userOrbiting = false;
    let clickSpin = 0;
    let clickSpinTarget = 0;
    let baseYaw = 25;
    const allowTilt = model.getAttribute('data-allow-tilt') === 'true';
    const lockedPitch = 72;

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

    const updateFromScroll = () => {
      const rect = root.getBoundingClientRect();
      const view = window.innerHeight || 1;
      const progress = clamp(
        1 - (rect.top + rect.height * 0.35) / (view + rect.height * 0.3),
        0,
        1
      );
      baseYaw = 25 + progress * 140;
    };

    const render = () => {
      if (!userOrbiting) {
        const yaw = baseYaw + clickSpin;
        const pitch = allowTilt
          ? 68 + Math.sin(((baseYaw + clickSpin) * Math.PI) / 180) * 4
          : lockedPitch;
        model.cameraOrbit = `${yaw.toFixed(2)}deg ${pitch.toFixed(2)}deg 105%`;
      }

      if (Math.abs(clickSpinTarget - clickSpin) > 0.2) {
        clickSpin += (clickSpinTarget - clickSpin) * 0.08;
      } else {
        clickSpin = clickSpinTarget;
      }

      window.requestAnimationFrame(render);
    };

    updateFromScroll();
    window.requestAnimationFrame(render);
    window.addEventListener('scroll', updateFromScroll, { passive: true });
    window.addEventListener('resize', updateFromScroll);

    model.addEventListener('mousedown', () => {
      userOrbiting = true;
    });
    model.addEventListener(
      'touchstart',
      () => {
        userOrbiting = true;
      },
      { passive: true }
    );

    const resumeScrollDrive = () => {
      window.setTimeout(() => {
        userOrbiting = false;
        updateFromScroll();
      }, 1800);
    };

    model.addEventListener('mouseup', resumeScrollDrive);
    model.addEventListener('touchend', resumeScrollDrive);

    model.addEventListener('click', () => {
      clickSpinTarget += 90;
      if (model.availableAnimations && model.availableAnimations.length) {
        try {
          model.play({ repetitions: 1 });
        } catch (e) {}
      }
    });

    model.addEventListener('load', () => {
      model.classList.add('is-ready');
      updateFromScroll();
    });
    if (model.loaded) model.classList.add('is-ready');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-sc-testimonials]');
    const scroller = document.querySelector('[data-sc-testimonials-scroller]');
    const track = document.querySelector('[data-sc-testimonials-track]');
    if (!root || !scroller || !track) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let offset = 0;
    let half = 0;
    let speed = 0.5;
    let dragging = false;
    let moved = false;
    let pressed = false;
    let axis = null;
    let startX = 0;
    let startY = 0;
    let startOffset = 0;
    let lastX = 0;
    let velocity = 0;
    let rafId = 0;
    let isHovered = false; 
    let currentSpeedMultiplier = 1; // Variabel baru untuk efek linger/halus
    const AXIS_LOCK = 8;

    const measure = () => {
      const group = track.querySelector('.sc-testimonials__group');
      half = group ? group.offsetWidth : Math.floor(track.scrollWidth / 2);
      const duration = Number.parseFloat(getComputedStyle(root).getPropertyValue('--sc-testimonials-duration')) || 45;
      speed = half > 0 ? half / (duration * 60) : 0.5;
    };

    const wrap = (value) => {
      if (half <= 0) return value;
      let next = value % half;
      if (next > 0) next -= half;
      return next;
    };

    const render = () => {
      track.style.transform = `translate3d(${offset}px, 0, 0)`;
    };

    const tick = () => {
      if (!reduceMotion) {
        const isMobile = window.innerWidth <= 749; 

        // Target kecepatan: 1 (jalan penuh) atau 0 (berhenti)
        const targetMultiplier = (!dragging && !isHovered && !isMobile) ? 1 : 0;
        
        // Logika LINGER / SMOOTHING: Mendekati target secara perlahan
        // Angka 0.05 bisa diperkecil (misal 0.02) jika ingin berhentinya LEBIH lambat/halus
        currentSpeedMultiplier += (targetMultiplier - currentSpeedMultiplier) * 0.05;

        // Terapkan kecepatan yang sudah dihaluskan
        if (Math.abs(currentSpeedMultiplier) > 0.001) {
          offset = wrap(offset - (speed * currentSpeedMultiplier));
        }

        // Momentum saat di-drag secara manual
        if (!dragging && Math.abs(velocity) > 0.1) {
          offset = wrap(offset + velocity);
          velocity *= 0.95;
        } else if (!dragging) {
          velocity = 0;
        }

        render();
      }
      rafId = window.requestAnimationFrame(tick);
    };

    const onDown = (event) => {
      if (event.button != null && event.button !== 0) return;
      measure();
      dragging = false;
      moved = false;
      pressed = true;
      axis = null;
      velocity = 0;
      startX = event.clientX;
      startY = event.clientY;
      lastX = event.clientX;
      startOffset = offset;
    };

    const onMove = (event) => {
      if (!pressed) return;
      const x = event.clientX;
      const y = event.clientY;
      const dx = x - startX;
      const dy = y - startY;

      if (axis === null) {
        if (Math.abs(dx) < AXIS_LOCK && Math.abs(dy) < AXIS_LOCK) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (axis !== 'x') return;
        dragging = true;
        scroller.classList.add('is-dragging');
        try {
          scroller.setPointerCapture(event.pointerId);
        } catch (e) {}
      }

      if (axis !== 'x') return;

      event.preventDefault();
      if (Math.abs(dx) > 2) moved = true;
      velocity = x - lastX;
      lastX = x;
      offset = wrap(startOffset + dx);
      render();
    };

    const onUp = (event) => {
      pressed = false;
      axis = null;
      if (!dragging) return;
      dragging = false;
      scroller.classList.remove('is-dragging');
      try {
        scroller.releasePointerCapture(event.pointerId);
      } catch (e) {}
    };

    // Deteksi hover
    scroller.addEventListener('mouseenter', () => isHovered = true);
    scroller.addEventListener('mouseleave', () => isHovered = false);

    scroller.addEventListener('pointerdown', onDown);
    scroller.addEventListener('pointermove', onMove);
    scroller.addEventListener('pointerup', onUp);
    scroller.addEventListener('pointercancel', onUp);
    scroller.addEventListener('lostpointercapture', onUp);

    scroller.addEventListener(
      'wheel',
      (event) => {
        if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
        if (!event.deltaX) return;
        event.preventDefault();
        velocity = 0;
        offset = wrap(offset - event.deltaX);
        render();
      },
      { passive: false }
    );

    scroller.addEventListener('click', (event) => {
      if (moved) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);

    track.addEventListener('dragstart', (event) => event.preventDefault());

    measure();
    render();
    rafId = window.requestAnimationFrame(tick);
    window.addEventListener('resize', () => {
      measure();
      offset = wrap(offset);
      render();
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        window.cancelAnimationFrame(rafId);
      } else {
        rafId = window.requestAnimationFrame(tick);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["value-cards"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sc-values]').forEach((root) => {
    const grid = root.querySelector('[data-sc-values-grid]');
    const bar = root.querySelector('[data-sc-values-scrollbar]');
    const thumb = root.querySelector('[data-sc-values-thumb]');
    if (!grid || !bar || !thumb) return;

    const mq = window.matchMedia('(max-width: 749px)');

    const update = () => {
      if (!mq.matches) {
        bar.hidden = true;
        thumb.style.width = '';
        thumb.style.transform = '';
        return;
      }

      const max = grid.scrollWidth - grid.clientWidth;
      if (max <= 1) {
        bar.hidden = true;
        return;
      }

      bar.hidden = false;
      const ratio = grid.clientWidth / grid.scrollWidth;
      const thumbWidth = Math.max(ratio * 100, 18);
      const travel = 100 - thumbWidth;
      const progress = grid.scrollLeft / max;
      thumb.style.width = thumbWidth + '%';
      thumb.style.transform = 'translateX(' + ((progress * travel) / thumbWidth) * 100 + '%)';
    };

    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (mq.addEventListener) mq.addEventListener('change', update);
    else mq.addListener(update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["when-to-sip"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sc-when-to-sip]').forEach((section) => {
    const items = section.querySelectorAll('.sc-when-to-sip__item');
    if (!items.length) return;

    const ensureOneOpen = () => {
      const anyOpen = Array.prototype.some.call(items, (item) => item.open);
      if (!anyOpen && items[0]) items[0].open = true;
    };

    items.forEach((item) => {
      const summary = item.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', (event) => {
          if (item.open) event.preventDefault();
        });
      }

      item.addEventListener('toggle', () => {
        if (item.open) {
          items.forEach((other) => {
            if (other !== item) other.removeAttribute('open');
          });
        } else {
          ensureOneOpen();
        }
      });
    });

    ensureOneOpen();
  });

  } catch(e) { console.error(e); }
})();
})();
